import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import Category from "./pages/Category";
import ToolPage from "./pages/ToolPage";
import Static from "./pages/Static";

const ADSENSE_ID = process.env.REACT_APP_ADSENSE_ID;

function App() {
  useEffect(() => {
    if (!ADSENSE_ID) return;
    // Inject AdSense script once
    const id = "adsbygoogle-loader";
    if (!document.getElementById(id)) {
      const s = document.createElement("script");
      s.id = id;
      s.async = true;
      s.crossOrigin = "anonymous";
      s.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${ADSENSE_ID}`;
      document.head.appendChild(s);
    }
  }, []);

  return (
    <BrowserRouter>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/category/:id" element={<Category />} />
          <Route path="/tool/:slug" element={<ToolPage />} />
          <Route path="/privacy" element={<Static title="Privacy Policy">
            <p>ToolHaus is built privacy-first. We do not require sign-up and we do not store the files you process. Uploaded files are processed in-memory and discarded immediately after returning your result.</p>
            <p>We use Google AdSense to fund free hosting. AdSense may set cookies for advertising personalization in line with Google's Privacy Policy.</p>
            <p>We collect anonymous, aggregated usage counts (number of tool runs / files processed) to show on the homepage. No personal data is associated with these counts.</p>
          </Static>} />
          <Route path="/terms" element={<Static title="Terms of Use">
            <p>ToolHaus is provided free of charge with no warranty. You agree not to use the tools for unlawful content or to upload material you do not have the right to process.</p>
            <p>Rate limits and abuse protection may apply. We may update tools or features without notice.</p>
          </Static>} />
          <Route path="/about" element={<Static title="About ToolHaus">
            <p>ToolHaus is a single-page hub of 24 hand-crafted utilities — AI writing helpers, PDF utilities, image tools and developer essentials. No accounts, no watermarks, no dark patterns.</p>
            <p>Our goal: be the cleanest, fastest place on the open web to get a small job done.</p>
          </Static>} />
          <Route path="/contact" element={<Static title="Contact">
            <p>Have feedback or a tool request? Email <a className="text-primary" href="mailto:hello@toolhaus.app">hello@toolhaus.app</a>.</p>
          </Static>} />
          <Route path="*" element={<Static title="Page not found"><p>The page you're looking for doesn't exist. Head back to <a className="text-primary" href="/">all tools</a>.</p></Static>} />
        </Routes>
      </Layout>
    </BrowserRouter>
  );
}

export default App;
